import Vue from 'vue'
import FrontApp from './front/Front.vue'
import { makeStore } from './front/store'

jQuery(document).ready(function(){
  jQuery('.c4d-si-collection').each(function(){
    let instance = jQuery(this).attr('id');
    let data = jQuery(this).text();
    data = data != '' ? JSON.parse(data) : false;
    if (data) {
      let store = makeStore(data);
      new Vue({
        el: '#' + instance,
        store,
        render: h => h(FrontApp),
      });
    }
  });
});



